{
  "AGENT_BOTS": {
    "HEADER": "Bots",
    "LOADING_EDITOR": "Loading editor...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "GLOBAL_BOT_BADGE": "Sistem",
    "AVATAR": {
      "SUCCESS_DELETE": "Avatar bota je uspešno obrisan",
      "ERROR_DELETE": "Greška prilikom brisanja avatara bota, pokušajte ponovo"
    },
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Bot name",
        "PLACEHOLDER": "Name your bot.",
        "ERROR": "Bot name is required."
      },
      "DESCRIPTION": {
        "LABEL": "Bot description",
        "PLACEHOLDER": "What does this bot do?"
      },
      "BOT_CONFIG": {
        "ERROR": "Please enter your CSML bot configuration above.",
        "API_ERROR": "Your CSML configuration is invalid. Please fix it and try again."
      },
      "SUBMIT": "Validate and save"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Select an agent bot",
      "DESC": "Assign an Agent Bot to your inbox. They can handle initial conversations and transfer them to a live agent when necessary.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Primeni",
      "DISCONNECT": "Disconnect bot",
      "SUCCESS_MESSAGE": "Successfully updated the agent bot.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Successfully disconnected the agent bot.",
      "ERROR_MESSAGE": "Could not update the agent bot. Please try again.",
      "DISCONNECTED_ERROR_MESSAGE": "Could not disconnect the agent bot. Please try again.",
      "SELECT_PLACEHOLDER": "Select bot",
      "COUNTRY_BOTS": {
        "TITLE": "Botovi po zemlji",
        "DESC": "Ovo sanduče opslužuje više zemalja. Konverzacija ide na bota svoje zemlje: prema prodavnici Kaufland, prema tržištu porudžbine Allegro, a inače prema jeziku na kom kupac piše. Sve ostale konverzacije idu na podrazumevanog bota iznad.",
        "COUNTRY": "Izaberite zemlju",
        "BOT": "Izaberite bota",
        "ADD": "Dodaj bota za zemlju",
        "REMOVE": "Ukloni",
        "DEFAULT_REQUIRED": "Prvo izaberite podrazumevanog bota. Bot zemlje ga zamenjuje samo za tu zemlju.",
        "DISCONNECT_ALL": "Isključi sve botove"
      }
    },
    "ADD": {
      "TITLE": "Configure new bot",
      "CANCEL_BUTTON_TEXT": "Otkaži",
      "API": {
        "SUCCESS_MESSAGE": "Bot added successfully.",
        "ERROR_MESSAGE": "Could not add bot. Please try again later."
      }
    },
    "LIST": {
      "404": "No bots found. You can create a bot by clicking the 'Configure new bot' button ↗",
      "LOADING": "Fetching bots...",
      "TABLE_HEADER": {
        "DETAILS": "Detalji bota",
        "URL": "Adresa veb zakačke"
      },
      "TYPE": "Bot type"
    },
    "DELETE": {
      "BUTTON_TEXT": "Izbriši",
      "TITLE": "Delete bot",
      "CONFIRM": {
        "TITLE": "Potvrdite brisanje",
        "MESSAGE": "Da li ste sigurni da želite da obrišete {name}?",
        "YES": "Da, obriši",
        "NO": "Ne, zadrži"
      },
      "SUBMIT": "Izbriši",
      "CANCEL_BUTTON_TEXT": "Otkaži",
      "DESCRIPTION": "Are you sure you want to delete this bot? This action is irreversible.",
      "API": {
        "SUCCESS_MESSAGE": "Bot deleted successfully.",
        "ERROR_MESSAGE": "Could not delete bot. Please try again."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Uredi",
      "LOADING": "Fetching bots...",
      "TITLE": "Edit bot",
      "CANCEL_BUTTON_TEXT": "Otkaži",
      "API": {
        "SUCCESS_MESSAGE": "Bot updated successfully.",
        "ERROR_MESSAGE": "Could not update bot. Please try again."
      }
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Avatar bota"
      },
      "NAME": {
        "LABEL": "Ime bota",
        "PLACEHOLDER": "Unesite ime bota"
      },
      "DESCRIPTION": {
        "LABEL": "Opis",
        "PLACEHOLDER": "Čime se bavi ovaj bot?"
      },
      "WEBHOOK_URL": {
        "LABEL": "Adresa veb zakačke",
        "PLACEHOLDER": "https://example.com/webhook"
      },
      "ERRORS": {
        "NAME": "Ime bota je obavezno",
        "URL": "Adresa veb zakačke je obavezna",
        "VALID_URL": "Unesite ispravan URL koji počinje sa http:// ili https://"
      },
      "CANCEL": "Otkaži",
      "CREATE": "Napravi bota",
      "UPDATE": "Ažuriraj bota"
    },
    "TYPES": {
      "WEBHOOK": "Webhook bot",
      "CSML": "CSML bot"
    }
  }
}
